enum VisibilityTypeOption {
    AvailableToEveryone = 'AvailableToEveryone',
    Hidden = 'Hidden',
    HiddenWhenNotOnSale = 'HiddenWhenNotOnSale',
}

export default VisibilityTypeOption;
